<div class="max-w-2xl mx-auto">
  <h1 class="text-2xl font-semibold text-gray-900 mb-6">{{ 'settings.language' | translate }}</h1>

  <div class="bg-white rounded-lg border border-gray-200 p-6 mb-4">
    <p class="text-gray-600 text-sm mb-4">{{ 'settings.languageDescription' | translate }}</p>

    <div class="space-y-2">
      <button
        (click)="selectLanguage('de')"
        type="button"
        [class]="
          'w-full flex items-center p-3 rounded-lg border-2 transition-colors ' +
          (currentLocale() === 'de'
            ? 'border-main bg-main/5'
            : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50')
        ">
        <div class="flex items-center justify-center w-5 h-5 mr-3">
          @if (currentLocale() === 'de') {
            <svg class="w-5 h-5 text-main" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7" />
            </svg>
          } @else {
            <div class="w-4 h-4 rounded-full border-2 border-gray-300"></div>
          }
        </div>
        <span
          [class]="
            'text-base ' +
            (currentLocale() === 'de' ? 'font-medium text-gray-900' : 'text-gray-700')
          ">
          {{ 'settings.languageDe' | translate }}
        </span>
      </button>

      <button
        (click)="selectLanguage('fr')"
        type="button"
        [class]="
          'w-full flex items-center p-3 rounded-lg border-2 transition-colors ' +
          (currentLocale() === 'fr'
            ? 'border-main bg-main/5'
            : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50')
        ">
        <div class="flex items-center justify-center w-5 h-5 mr-3">
          @if (currentLocale() === 'fr') {
            <svg class="w-5 h-5 text-main" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7" />
            </svg>
          } @else {
            <div class="w-4 h-4 rounded-full border-2 border-gray-300"></div>
          }
        </div>
        <span
          [class]="
            'text-base ' +
            (currentLocale() === 'fr' ? 'font-medium text-gray-900' : 'text-gray-700')
          ">
          {{ 'settings.languageFr' | translate }}
        </span>
      </button>
    </div>
  </div>
</div>
